
import UpdateFarmModal from "@/components/Modals/UpdateFarmModal.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { gettersInstance, propsInstance } from "@/lib/util";
import { RawLocation } from "vue-router";

const Props = propsInstance<{
  via?: string;
}>({
  via: { type: String, default: "Unknown" },
});

const StoreGetters = gettersInstance(["farmIds", "user", "currentFarm", "isDemoFarm", "farmsWithSeasons"]);

@Component({
  name: "AddFarmButton",
  components: { UpdateFarmModal },
})
export default class AddFarmButton extends mixins(MixedVue, Props, StoreGetters) {
  static components: {
    UpdateFarmModal: typeof UpdateFarmModal;
  };

  showModal = false;

  get newAccountRoute(): RawLocation {
    const ref = this.currentFarm ? (this.isDemoFarm ? "demo_farm" : "shared_farm") : "shared_parcel";
    return { name: "new-account", query: { ref } };
  }

  get farmsWithSeasonsAndParcels() {
    return this.farmsWithSeasons.filter((farm) => farm.parcel_count > 0);
  }

  get importRoute(): RawLocation {
    if (!this.farmIds || this.farmIds.length === 0) return "";
    return {
      name: "manage-farm",
      params: {
        farmId: this.farmIds[0],
      },
    };
  }

  get farmRoute(): RawLocation {
    const farm = this.farmsWithSeasonsAndParcels.find((farm) => farm.ownedFarm);
    return {
      name: "map",
      params: { farmId: farm.id },
    };
  }
}
